import { Pipe, PipeTransform } from '@angular/core';
// import { SelectItem } from 'primeng/api/selectitem';

@Pipe({
  name: 'getLabelOf'
})
export class GetLabelFromValue implements PipeTransform {
  // transform(items: SelectItem[], value: any): string {
  transform(items: any[], value: any): string {
    if (items == null || items.length == 0) {
      return "N/A";
    } else {
      let f = items.find(e => e.value == value);

      if (f == null) {
        return null;
      } else {
        return f.label
      }

    }
  }
}